export default __webpack_public_path__ + "static/media/city_light_original.9642f475.jpg";